@use "~theme/typography";
@use "~theme/breakpoints";

.container {
  margin: {
    top: 28px;
    left: auto;
    bottom: 28px;
    right: auto;
  }
  width: 100%;
  max-width: 826px;

  @include breakpoints.desktop {
    margin-top: 56px;
  }
}

.containerNew {
  margin: {
    top: 28px;
    left: auto;
    bottom: 28px;
    right: auto;
  }
  width: 100%;

  @include breakpoints.desktop {
    margin-top: 56px;
  }
}

.youreScheduled {
  @include typography.heading2;
  color: var(--blue-01);
  text-align: center;
  margin-bottom: 12px;
}

.subheader {
  @include typography.heading4;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 0;

  @include breakpoints.desktop {
    flex-grow: 0;
    margin-bottom: 64px;
  }
}

.twoColumns {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0;

  @include breakpoints.desktop {
    flex-direction: row;
    margin-top: 14px;
  }
}

.column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}

.calendarButton {
  flex-grow: 0;
  margin-left: var(--card-gutter-width);
  margin-right: var(--card-gutter-width);
  margin-bottom: var(--card-gutter-width);
  width: calc(100% - calc(2 * #{var(--card-gutter-width)}));
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-top: 1px solid var(--blue-02-at-30);

  margin: {
    top: 38px;
    left: var(--card-gutter-width);
    right: var(--card-gutter-width);
  }
  padding-top: 28px;

  @include breakpoints.desktop {
    margin-top: 40px;
  }
}

.message {
  margin: 0;
  text-align: left;
  max-width: 302px;

  @include breakpoints.desktop {
    max-width: 352px;
  }
}

.confirmIcon {
  width: 48px;
  margin-right: 28px;
}

.caption {
  color: var(--black-at-75);
  padding-top: 8px;

  @include typography.caption;
}

.footerDivider {
  margin: 28px 0;
  height: 1px;
  border: 0;
  color: var(--blue-01-at-30);

  @include breakpoints.desktop {
    flex-shrink: 0;
    height: auto;
    width: 1px;
    margin: 0 64px;
  }
}
